import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const SegmentedCircularProgress = ({ value }: { value?: number }) => {
    const segments = 16; // Number of segments
    const segmentAngle = 360 / segments; // Angle per segment
    const filledSegments = Math.round((value! / 100) * segments); // Segments to fill

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
            }}
        >
            <svg width={150} height={150} viewBox="0 0 42 42">
                <circle
                    cx="21"
                    cy="21"
                    r="15.9155"
                    fill="transparent"
                    stroke="#D7DBEC"
                    strokeWidth="5"
                    strokeDasharray="20 100"
                    strokeDashoffset={25}
                />
                {Array.from({ length: segments }).map((_, i) => (
                    <circle
                        key={i}
                        cx="21"
                        cy="21"
                        r="15.9155"
                        fill="transparent"
                        stroke={i < filledSegments ? '#BBA57A' : '#D7DBEC'}
                        strokeWidth="5"
                        strokeDasharray="20 100"
                        strokeDashoffset={25}
                        transform={`rotate(${i * segmentAngle - 90 + 22.5} 21 21)`} // Start from the top
                    />
                ))}
            </svg>
            {(
                <Box
                    sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        variant="caption"
                        component="div"
                        sx={{
                            color: '#BBA57A',
                            fontWeight: 'bold',
                            fontSize: '20px',
                        }}
                    >{`%${Math.round(value!)}`}</Typography>
                </Box>
            )}
        </Box>
    );
};

export default function SegmentedCircularWithValueLabel({
    progress,
}: {
    progress: number;
}) {

    return <SegmentedCircularProgress value={progress} />;
}
